export const editLayer = (data, mapLayers, openEditLayer) => {
  let mCopy = JSON.parse(JSON.stringify(mapLayers));
  let currentLayer = JSON.parse(JSON.stringify(openEditLayer.data));
  let newLayer = JSON.parse(JSON.stringify(data));
  newLayer.isUpdated = true;

  let listIndex = openEditLayer.listIndex;

  if (listIndex.length === 1) {
    let i1 = listIndex[0];
    let newData = mCopy.layerCategories[i1].layerSettings.map(ls => {
      if (ls.id === currentLayer.id) {
        return {
          ...ls,
          ...data
        };
      }

      return ls;
    });
    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerSettings = newData;
  } else if (listIndex.length === 2) {
    let i1 = listIndex[0];
    let i2 = listIndex[1];
    let newData = mCopy.layerCategories[i1].layerCategories[
      i2
    ].layerSettings.map(ls => {
      if (ls.id === currentLayer.id) {
        return {
          ...ls,
          ...data
        };
      }

      return ls;
    });

    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerSettings = newData;
  } else if (listIndex.length === 3) {
    let i1 = listIndex[0];
    let i2 = listIndex[1];
    let i3 = listIndex[2];
    let newData = mCopy.layerCategories[i1].layerCategories[i2].layerCategories[
      i3
    ].layerSettings.map(ls => {
      if (ls.id === currentLayer.id) {
        return {
          ...ls,
          ...data
        };
      }

      return ls;
    });

    mCopy.layerCategories[i1].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerCategories[
      i3
    ].isUpdated = true;
    mCopy.layerCategories[i1].layerCategories[i2].layerCategories[
      i3
    ].layerSettings = newData;
  }

  return JSON.parse(JSON.stringify(mCopy));
};
